export const environment = {
  production: false,
  api_url: 'https://pp.codemixtechnology.com',
  // api_url: 'https://api.pipitcmp.com',
};
